import apiAthleteResults from '@/api/athlete-result'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createAthleteResultStart:
    '[create athlete result] Create athlete result start',
  createAthleteResultSuccess:
    '[create athlete result] Create athlete result success',
  createAthleteResultFailure:
    '[create athlete result] Create athlete result failure'
}

export const actionTypes = {
  createAthleteResult: '[create athlete result] Create athlete result'
}

const mutations = {
  [mutationTypes.createAthleteResultStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.createAthleteResultSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createAthleteResultFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createAthleteResult](context, {athleteResult}) {
    context.commit(mutationTypes.createAthleteResultStart)
    return new Promise(resolve => {
      apiAthleteResults
        .createAthleteResult(athleteResult)
        .then(response => {
          context.commit(mutationTypes.createAthleteResultSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createAthleteResultFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
